export const personConfig = {
  "@id": "https://ladi-bello.netlify.app",
  "@type": "Person",
  type: "Person",
  name: "Bello Oladipupo",
  alternateName: "Bello Ladi",
  url: "https://ladi-bello.netlify.app",
  sameAs: [
    // 'http://www.facebook.com/your-profile',
    // 'http://instagram.com/yourProfile',
    "https://www.linkedin.com/in/oladipupo-bello-755897152",
    // 'http://plus.google.com/your_profile',
    "https://github.com/DavyBello",
  ],
  image: {
    "@type": "ImageObject",
    inLanguage: "en-UK",
    "@id": "https://ladi-bello.netlify.app#image",
    url: "https://ladi-bello.netlify.app/profile.png",
    contentUrl: "https://ladi-bello.netlify.app/profile.png",
    width: 200,
    height: 200,
    caption: "Bello Oladipupo",
  },
  description:
    "Ladi is a Software Engineer turned Engineering Manager. He is passionate about building Software and High-Performing teams.",
  email: "davybello51@gmail.com",
};